export default {
  date: 'December 20, 2024',
  title: 'Free Demo Floor Plan: New Offer from Getfloorplan',
  description: 'Try our service risk-free with a free demo plan',
  id: 'free-demo-floor-plan',
  jsx: () => (
    <div class='novelty__text'>
      <p>We’re excited to introduce a special offer for our clients! Now, when you purchase a package of 6 or more floor plans, you can receive a test floor plan completely free.</p>
      <b>How does it work?</b>
      <p>It’s simple:</p>
      <p style='margin-left: 30px'>
        1. Submit a request on our website.
        <br></br>
        2. Click the
        <a href='https://getfloorplan.com/#gallerySection'> "Ask demo" </a>
        button and let us know you’re interested in a demo for your project.
        <br></br>
        3. Our client manager will contact you to clarify project details and create a personalized offer.
      </p>
      <p>To create the test floor plan, you’ll just need to provide a single file with a floor layout to the manager.</p>
      <p>
        <b>Why is this beneficial?</b>
      </p>
      <ul style='margin-left: 50px'>
        <li class='margin-none'>Test the quality of our services at no additional cost.</li>
        <li class='margin-none'>Receive a floor plan tailored perfectly to your project.</li>
        <li class='margin-none'>Ensure Getfloorplan is the reliable partner you need for your tasks.</li>
      </ul>
      <p>Don’t miss this opportunity to start working with us on the best terms!</p>
    </div>
  ),
  thumb: 'news/34.webp',
};
